<div class="row">
  <div class="col">
    <sb-card [loading]="loadingInviteCode">
      <div card-body>
        <h3 class="font-black">{{ 'lang.clientManagement.invitationLink' | translate }}</h3>
        <a class="mt-2" *ngIf="invitationCode"
           [href]='invitationLink'
           target="_blank">
          {{ invitationLink }}
        </a>
        <div class="mt-2">
          <sb-button
            *ngIf="invitationCode"
            classes="btn-primary btn-sm"
            icon="copy" (click)="copy()">
            Kopieren
          </sb-button>
          <sb-button
            [classes]="'btn-secondary btn-sm ' + (!invitationCode ? 'mt-2' : '')"
            icon="refresh" (click)="generateNew()">
            Neu generieren
          </sb-button>
        </div>
      </div>
    </sb-card>
  </div>
</div>

<sb-table-client-connections-incoming></sb-table-client-connections-incoming>
<br />
<sb-table-client-connections-send></sb-table-client-connections-send>
